import { AdminPanelOption, AdminUser } from "../../models/admin";

export const admin = "Admin";
export const basic = "Basic";
export const t1aAdmin="T1aAdmin"; //Partner Menu
export const partnerRoles="PartnerAdmin,ResellerAdmin,CustomerAdmin,PartnerUser"; //Partner Menu
export const partnerUserRoles="ResellerUser,CustomerUser";

export const partnerSuperAdmin = "Partner Super Admin";
export const customer = "Customer";
export const resellerCustomer="Reseller Customer";

export const kamDistributorPrice = "Kam_Distributor_Price";
export const kamEstimatedSalesPrice = "Kam_Estimated_Sales_Price";
export const availableDistributorStock = "Available_Distributor_Stock";
export const onOrderDistributorStock = "OnOrder_Distributor_Stock";

export const adminMenuOptions = [
    { key: "Users", text: "Users", value: true },
    { key: "Collection", text: "Collection", value: false },
    { key: "Settings", text: "Settings", value: false },
    { key: "UserCountry", text: "User Country", value: false },
    { key: "KamPrice", text: "Kam Price", value: false },
    { key: "StockCountry", text: "Stock Country", value: false },
    { key: "ProductLines", text: "Prod. Lines", value: false },
    { key: "EmpType", text: "Emp. Type", value: false },
]

export const admUsers = "Users";
export const collection = "Collection";
export const admSettings = "Settings";
export const admUserCountry = "UserCountry";
export const admStockCountry = "StockCountry";
export const admKamPrice = "KamPrice";
export const admProductLines = "ProductLines";
export const admEmpType = "EmpType";

export const adminPanelOptionToggle = () => {
    const options: AdminPanelOption[] = [];
    for (const iterator of adminMenuOptions) {
        const opt: AdminPanelOption = {
            optionName: iterator.text,
            toggle: iterator.value,
            key: iterator.key
        }
        options.push(opt)
    }
    return options;
};

export const UserActivityStatus = (user: AdminUser) => {
    return user.blocked ? 'Blocked'
        : user.approved && user.emailConfirmed ? 'Activated'
            : user.approved && !user.emailConfirmed ? 'Email Conf.'
                : !user.approved && !user.emailConfirmed ? 'Activate'
                    : 'Blocked';
}